export default __webpack_public_path__ + "static/media/Spreadsheet.dc166d10.svg";